export default "/images/vendor/quill/icons/header.svg?8c2dc93d4be101f76bae77761ec90c8e";